import {RESET_SUCCESS} from "./types";

export const resetSuccess = () => dispatch => {
    dispatch({
        type: RESET_SUCCESS
    });
}